import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSucceeded } from '../../redux/auth/actions';
import { getOidcManager, oidcUserToSession } from '../../service/auth/oidc';

export default function OidcCallback() {
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const callbackHandled = useRef(false);

  useEffect(() => {
    // React Strict Mode deliberately re-runs effects in development. An OIDC
    // authorization code is single-use, so the second exchange must not run.
    if (callbackHandled.current) return;
    callbackHandled.current = true;

    void getOidcManager().signinRedirectCallback()
      .then(async (user) => {
        await dispatch<any>(loginSucceeded(oidcUserToSession(user)));
        const destination = sessionStorage.getItem('oidc:returnTo') || '/';
        sessionStorage.removeItem('oidc:returnTo');
        // The roles are not known until the app loads, so the app makes the platform-console
        // decision (App.tsx). An invitation link is an explicit destination and is kept.
        if (!destination.startsWith('/invitations/')) {
          sessionStorage.setItem('oidc:freshSignIn', '1');
        }
        window.location.replace(destination);
      })
      .catch(() => setError('Sign-in could not be completed. Please try again.'));
  }, [dispatch]);

  return <main className="p-6">{error || 'Completing secure sign-in…'}</main>;
}
